import { Injectable } from '@angular/core';

import {
  Company,
} from 'app/models';

@Injectable({
  providedIn: 'root'
})
export class ChangeProfilesService {
  private _users: any[] = []; // handle Profile and Invitation types

  addUser(user: any): void {
    this._users.push(user);
  }

  removeUser(user: any): void {
    let userIndex;
    if (user.isInvite) {
      userIndex = this._users.findIndex(u => u.email === user.email);
    } else {
      userIndex = this._users.findIndex(u => u.authID === user.authID);
    }
    if (userIndex === -1) {
      return;
    }
    this._users.splice(userIndex, 1);
  }

  clearUsers(): void {
    this._users = [];
  }

  getUsers(): any[] {
    return this._users;
  }
}
